export default __webpack_public_path__ + "img/dataPipes.f2e83a9f.jpg";